
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    UNASSIGN_DRIVERS_GET_KEYFOB_REQUEST,
    UNASSIGN_DRIVERS_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { unassignDriversGetKeyFobResult, unassignDriversResult } from 'Redux/actions';


function* getKeyFobs({ payload }) {
    try {

        let { devices } = payload;
        const QUERY = `
        query searchKeyFobs ($conditions: [KeyFobSearchInput], $sort: [KeyFobSortInput], $limit: Int, $offset: Int) {
            result: searchKeyFobs (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    companyId
                    id
                    hex
                    company {
                        id
                        name
                    }
                    keyFobModel {
                        id
                        name
                    }
                    driver {
                        name
                    }
                }
                total
            }
        }
        `;

        let data = yield call(
            clientQuery,
            QUERY,
            {
                conditions: {
                    fields: ["hex"],
                    terms: payload,
                    exact: true
                },
                limit: 500,
                offset: 0
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) {
            yield put(unassignDriversGetKeyFobResult(data?.result))
        } else {
            yield put(unassignDriversGetKeyFobResult({ error: true }))
        }

    } catch (exc) {
        yield put(unassignDriversGetKeyFobResult({ error: true }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/unassignDrivers/redux/saga",
            "getKeyFobs",
        )
    }
}

function* unassignDrivers({ payload }) {
    try {
        let { keyFobIds } = payload
        let QUERY = ` 
            
            mutation unassignDrivers ($keyFobIds: [String]!) {
                unassignDrivers (keyFobIds: $keyFobIds)
            }
        
        `;

        let data = yield call(
            clientMutation,
            QUERY,
            {
                keyFobIds: keyFobIds
            },
            endpoints.GRAPHQL_GENERAL,
        );
        if (data) { //data?.result
            yield put(unassignDriversResult({ updateMoveAccount: true }))
        } else {
            yield put(unassignDriversResult({ updateMoveAccount: false }))
        }

    } catch (exc) {
        yield put(unassignDriversResult({ updateMoveAccount: false }))
        ExceptionManager(
            exc,
            "Modules/devices/.components/unassignDrivers/redux/saga",
            "unassignDrivers",
        )
    }
}

export const getAccounts = async (input = '') => {
    try {
        let QUERY = `
        query searchCompanies ($conditions: [CompanySearchInput], $sort: [CompanySortInput], $limit: Int, $offset: Int) {
            result: searchCompanies (conditions: $conditions, sort: $sort, limit: $limit, offset: $offset) {
                items {
                    id
                    name
                    status
                }
            }
        }`
        return await clientQuery(QUERY, {
            conditions: {
                fields: [
                    "name"
                ],
                terms: [
                    input
                ],
                exact: false
            },
            limit: 10
        }, endpoints.GRAPHQL_GENERAL);
    } catch (exc) {
        ExceptionManager(exc, 'Modules/activities/.components/tab/redux/saga', 'getAccounts');
    }
}

function* watchMethods() {
    yield takeEvery(UNASSIGN_DRIVERS_GET_KEYFOB_REQUEST, getKeyFobs);
    yield takeEvery(UNASSIGN_DRIVERS_REQUEST, unassignDrivers);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}